module.exports = __webpack_public_path__ + "img/13.c958b5aa.jpg";